import script from "./Dashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dashboard.vue?vue&type=script&lang=ts&setup=true"

import "./Dashboard.vue?vue&type=style&index=0&id=93836356&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93836356"]])

export default __exports__